<template>
  <div>
    <page-title icon="fas fa-table" main="Cadastro" sub="Filiais"
      :help="true" titleHelp="Ajuda - Filiais"
      content="Responsável por listar filiais e suas devidas regiões.
        Para criação pressione o botão no canto superior direito 'Cadastro'.
        Para alteração de uma Filial basta ir com o mouse em ações e clicar em Editar."
      >
      <template v-slot:actions>
        <base-button @click="modals.modal0 = true" type="neutral" class="ml-3" size="sm">Cadastro</base-button>
      </template>
    </page-title>
    <modal :show.sync="modals.modal0" id="cadastrar-seções" size="lg">
      <template slot="header"> 
        <h5 class="modal-title" id="exampleModalLabel">{{ formData.id ? 'Editar Filial' : 'Cadastrar Filial'}}</h5>
      </template>
      <validation-observer ref="observer">
        <form role="form">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12">
              <div class="row">
                <div class="col-12 col-sm-12 col-md-12">
                  <ValidationProvider vid="anosafra" name="anosafra" rules="required" v-slot="{ errors }">
                    <base-input :required="true" :error="errors[0]">
                      <anosafra-multiselect
                        v-model="formData.anosafras"
                        label="Ano Safra"
                        :multiple="true"
                        :close-on-select="false"
                        :required="true"
                      />
                    </base-input>
                  </ValidationProvider>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-12 col-md-12"">
                  <label class="form-control-label">Unidade<span class="text-danger"> *</span></label>
                  <ValidationProvider
                    vid="unity"
                    name="unity"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <base-input
                      :required="true"
                      :error="errors[0]"
                    >
                      <multiselect
                        v-model="formData.unity"
                        :options="unities"
                        :filterable="true"
                        placeholder="Escolha uma unidade"
                        track-by="id"
                        label="description"
                        :open-direction="'bottom'"
                      />
                    </base-input>
                  </ValidationProvider>
                </div>
                <div class="col-12 col-sm-12 col-md-12"">
                  <ValidationProvider
                    vid="branch"
                    name="branch"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label class="form-control-label">Nome da filial<span class="text-danger"> *</span></label>
                    <base-input
                      placeholder="Nome da Filial"
                      v-model="formData.branch"
                      name="branch"
                      rules="required"
                      :error="errors[0] || branchError"
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>
        </form>
      </validation-observer>
      <template slot="footer">
        <base-button type="secondary" @click="modals.modal0 = false">Fechar</base-button>
        <base-button type="success" @click="saveBranch">Salvar</base-button>
      </template>
    </modal>
    <card>
      <div slot="header">
        <span>Filiais</span>
      </div>
      <form>
        <div class="row">
          <div class="col-md-4">
            <anosafra-multiselect
              v-model="filter.anosafras"
              label="Ano Safra"
              :multiple="true"
              :close-on-select="false"
              :limit-text="(count) => ` + ${count}`"
              @input="handleAnosafraChange()"
            />
          </div>
          <div class="col-md-4">
            <label class="form-control-label">Unidade</label>
            <multiselect
              v-model="filter.unity"
              :options="unities"
              placeholder="Selecionar Ano Safra"
              label="description"
              track-by="id"
              @input="filterBranchOptions()"
            ></multiselect>
          </div>
          <div class="col-md-4">
            <label class="form-control-label">Filial</label>
            <multiselect
              v-model="filter.branch"
              :options="branchesOptions"
              placeholder="Selecionar Filial"
              label="name"
              :selected-label="'Selecionado'"
              track-by="id"
              :allow-empty="true"
            />
          </div>
          <div class="col-md-12 mb-4 mt-3 d-flex justify-content-end">
            <base-button class="mr-2" type="neutral" @click="clearFilter()">
              Limpar Filtros
            </base-button>
            <base-button type="primary" @click="searchBranch()">
              Filtrar
              <i class="fas fa-search"></i>
            </base-button>
          </div>
        </div>
      </form>
      <el-table
        ref="table"
        class="table-responsive table-striped clickable-rows"
        header-row-class-name="thead-light"
        :data="branches"
        v-loading="loading.branches || loading.destroy"
      >
        <el-table-column label="Unidade" min-width="180px" prop="unity.description" sortable></el-table-column>
        <el-table-column label="Nome da Filial" min-width="220px" prop="name" sortable></el-table-column>
        <el-table-column label="Ações" min-width="50px" v-slot="{ row }">
          <el-dropdown trigger="hover" class="dropdown" style="cursor: pointer;">
            <span class="btn btn-sm btn-icon-only text-success">
              <i class="fas fa-ellipsis-v mt-2"></i>
            </span>
            <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
              <a class="dropdown-item" @click="editBranch(row)">Editar</a>
              <!-- a funcionalidade não será utilizada no momento. não remover codigo -->
              <!-- <a class="dropdown-item" @click="destroyBranch(row)">Excluir</a> -->
            </el-dropdown-menu> 
          </el-dropdown> 
        </el-table-column>
        <el-table-column label="Visualizar" min-width="50px">
          <template v-slot="{ row }">
            <a @click="toggleRowExpansion(row)">
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fa fa-eye mt-2"></i>
              </span>
            </a>
          </template>
        </el-table-column>
        <el-table-column :min-width="1" type="expand">
          <template v-slot="{ row }">
            <div class="card-deck">
              <card>
                <h5 class="card-title">Regiões Vinculadas</h5>
                <el-collapse-transition>
                  <div v-if="row.regions && row.regions.length" class="tags-input__wrapper">
                    <el-tag
                      v-for="(region, index) in row.regions"
                      :key="index"
                      size="mini"
                      effect="dark"
                      :closable="false"
                      class="ml-1 mt-1"
                    >
                      {{ region.name }}
                    </el-tag>
                  </div>
                  <div v-else>
                    <p>Nenhuma região vinculada.</p>
                  </div>
                </el-collapse-transition>
              </card>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="py-4 d-flex justify-content-end">
        <base-pagination
          @input="changePage"
          v-model="paginated_data['page']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        ></base-pagination>
      </div>
    </card>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, getCurrentInstance } from 'vue';
import axios from "@/backend/axios/index.js";
import store from '@/store';
import swal from "sweetalert2";
import PageTitle from '@/layouts/PageTitle';
import Multiselect from '@/components/Multiselect/translated_multiselect.vue';
import AnosafraMultiselect from '@/components/Multiselect/anosafra_multiselect.vue';
import { DropdownMenu, Dropdown, Table, TableColumn, Tag } from 'element-ui';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import { ValidationProvider, extend } from 'vee-validate';
extend("required", {
  ...require,
  message: "Este campo é obrigatório",
});

const ElTag = Tag
const ElTable = Table
const ElDropdown = Dropdown
const ElTableColumn = TableColumn
const ElDropdownMenu = DropdownMenu
const ElCollapseTransition = CollapseTransition

const APP = getCurrentInstance();
const toasted = APP.proxy.$toasted;

const errorMessages = ref([]);

const loading = ref({
  branches: false,
  destroy: false
})

const formData = ref({
  anosafras: [],
  unity: null,
  branch: ""
});

const filter = ref({
  anosafras: [],
  unity: null,
  branch: null
});

const anosafraOptions         = ref([]);
const originalAnosafraOptions = ref([])
 
const unities   = ref([]);
const branches  = ref([]);
const observer  = ref(null);
const modals    = ref({ modal0: false });

const currentPage         = ref(null)
const paginated_data      = ref([])
const branchesOptions     = ref([])
const allAnosafraselected = ref(false);

const table = ref(null);
const expandedRow = ref(null);

const toggleRowExpansion = (row) => {
  if (!table.value) return;

  if (expandedRow.value !== row) {
    table.value.toggleRowExpansion(expandedRow.value, false);
  }

  expandedRow.value = expandedRow.value === row ? null : row;
  table.value.toggleRowExpansion(row, !!expandedRow.value);
};

const saveBranch = async () => {
  const validForm = await observer.value.validate(); 
  if (!validForm) return;

  if (!formData.value.id) return await createBranch();
  
  return await updateBranch();
};

const restoreAnosafraOptions = () => {
  anosafraOptions.value = [...originalAnosafraOptions.value];
}

const editBranch = (row) => {
  const linkedAnosafras = anosafraOptions.value.filter(anosafra =>
    row.anosafra_branches.some(branch => branch.anosafra_id === anosafra.id)
  )

  anosafraOptions.value = linkedAnosafras

  formData.value = {
    id: row.id,
    anosafras: linkedAnosafras,
    anosafra_branches: row.anosafra_branches,
    unity: row.unity || null,
    branch: row.name || "",
  };

  modals.value.modal0 = true;
};

const branchError = computed(() => {
  return errorMessages.value.some(el => 
  el.match(/nome já existe/) || 
  el.match(/Anosafra branches branch name já existe no anosafra/)
  ) ? "Já existe uma filial cadastrada com este nome. Escolha um nome diferente." : null;
});

const changePage = async(page) => {
  currentPage.value = page;

  const filter = await formatedFilter()
  await getBranches(page, filter);
}

const currentAnosafra = computed(() => store.state.currentAnosafra);

const setCurrentAnosafra = async () => {
  const selectedAnosafra = anosafraOptions.value.find(
    (anosafra) => anosafra.id === currentAnosafra.value.id
  );

  filter.value.anosafras = selectedAnosafra ? [selectedAnosafra] : [];
};

const formatedFilter = async () => {
  const filterParams = {};

  if(filter.value.anosafras && filter.value.anosafras.length > 0) {
    filterParams.anosafra_ids = filter.value.anosafras.map(anosafra => anosafra.id)
  }

  if(filter.value.branch) {
    filterParams.id = filter.value.branch.id
  }

  if(filter.value.unity) {
    filterParams.unity_id = filter.value.unity.id
  }

  return filterParams
}

const searchBranch = async(page) => {
  const filter = await formatedFilter()

  if(Object.keys(filter).length === 0) return 

  await getBranches(page, filter)
}

const clearFilter = async () => {
  if(!filter.value.anosafras.length && !filter.value.unity && !filter.value.branch) return

  filter.value.anosafras = []
  filter.value.unity     = null
  filter.value.branch    = null

  await getBranches()
  await getBranchesOptions()
}

const createBranch = async () => {
  const formattedBranch = {
    branch: {
      unity_id: formData.value.unity.id,
      name: formData.value.branch,
      anosafra_branches_attributes: formData.value.anosafras.map(anosafra => ({
        anosafra_id: anosafra.id,
        branch_name: formData.value.branch
      }))
    }
  }
  
  try {
    await axios.post(`/api/v1/branches`, formattedBranch)
    await requestSuccess(currentPage)
  } catch (error) {
    errorMessages.value = error.response.data.errors;
    console.warn("[Branch][CreateBranch]", error);
  }
}

const updateBranch = async () => {
  const formattedBranch = {
    branch: {
      unity_id: formData.value.unity.id,
      anosafra_branches_attributes: formData.value.anosafras.map(anosafra => {
        const anosafraBranch = formData.value.anosafra_branches.find(branch => branch.anosafra_id === anosafra.id);

        return {
          id: anosafraBranch ? anosafraBranch.id : null,
          anosafra_id: anosafra.id,
          branch_name: formData.value.branch
        };
      })
    }
  };

  try {
    await axios.put(`/api/v1/branches/${formData.value.id}`, formattedBranch)
    await requestSuccess(currentPage)
  } catch (error) {
    errorMessages.value = error.response.data.errors;
    console.warn("[Branch][updateBranch]", error);
  }
}

// a funcionalidade não será utilizada no momento. não remover codigo
const destroyBranch = async (branch) => {
  const result = await swal.fire({
    title: `Excluir  Filial`,
    text: `Ao excluir esta filial você estará excluindo
      todas as regiões vinculadas a ela a partir deste
      ano safra. Tem certeza que deseja prosseguir com a exclusão?`,
    showCancelButton: true,
    confirmButtonText: 'Continuar',
    cancelButtonText: 'Cancelar',
    buttonsStyling: false,
    confirmButtonClass: "btn btn-primary mr-2",
    cancelButtonClass: "btn btn-secondary",
  })

  if (!result.isConfirmed) return 

  loading.value.destroy = true

  try { 
    await axios.delete(`/api/v1/branches/${branch.id}`);

    const index = branches.value.findIndex(s => branch.id === s.id);
    if (index !== -1) {
      branches.value.splice(index, 1);
    }

    toasted.global.defaultSuccess()
  } catch (error) {
    toasted.global.defaultError({msg: 'Infelizmente não foi possível concluir o processo de exclusão. Tente novamente em alguns minutos.'});
  } finally {
    loading.value.destroy = false
  }
};
 
const selectAllAnosafra = () => {
  if (allAnosafraselected.value) {
    formData.value.anosafras = [];
  } else {
    formData.value.anosafras = [...anosafraOptions.value];
  }
  allAnosafraselected.value = !allAnosafraselected.value;
};
const getUnities = async () => {
  try {
    const response = await axios.get("/api/v1/unities");
    unities.value = response.data;
  } catch (error) {
    console.warn("[Branch][getUnities]", error);
  }
};

const requestSuccess = async (page) => {
  toasted.global.defaultSuccess();
  modals.value.modal0 = false
  
  const filter = await formatedFilter()
  page = currentPage.value ? currentPage.value : 1

  await getBranches(page, filter)
}

const resetInputs = () => {
  formData.value.id = null
  formData.value.branch = null
  formData.value.unity = null
  formData.value.anosafras = []
  errorMessages.value = []
  observer.value.reset();
}

const getBranchName = (branch, selectedAnosafra) => {
  let branchName = branch.name;

  if (branch.anosafra_branches && branch.anosafra_branches.length > 0) {
    const matchingAnosafra = branch.anosafra_branches.find(
      (ab) => ab.anosafra_id === selectedAnosafra.id
    );

    if (matchingAnosafra && matchingAnosafra.branch_name && matchingAnosafra.branch_name !== null) {
      branchName = matchingAnosafra.branch_name;
    }
  }

  return branchName;
};

const getBranches = async (page = 1, filterParams) => {
  loading.value.branches = true

  try {
    const filterString = JSON.stringify(filterParams);
    const response = await axios.get("/api/v1/branches", {
      params: { 
        page: page,
        q: filterString
      }
    });

    paginated_data.value = response.data;

    branches.value = response.data.branches.map(branch => {
      const selectedAnosafra = filter.value.anosafras && filter.value.anosafras.length > 0
        ? filter.value.anosafras[0]
        : currentAnosafra.value;

      const branchName = getBranchName(branch, selectedAnosafra);

      return {
        ...branch,
        name: branchName,
      };
    });
  } catch (error) {
    console.warn("[Branch][getBranches]", error);
  } finally {
    loading.value.branches = false
  }
};

const handleAnosafraChange = () => {
  if (filter.value.anosafras.length === 0 && !filter.value.unity && !filter.value.branch) {
    getBranches() 
  } 
  
  filterBranchOptions();
};

const filterBranchOptions = async () => {
  const filter = await formatedFilter()
  
  return await getBranchesOptions(filter)
}

const getBranchesOptions = async (formatFilter) => {
  try {
    const response = await axios.get("/api/v1/branches", {
      params: {
        q: formatFilter
      }
    })

    branchesOptions.value = response.data.map((branch) => {
      const selectedAnosafra = filter.value.anosafras && filter.value.anosafras.length > 0
        ? filter.value.anosafras[0]
        : currentAnosafra.value;

      const branchName = getBranchName(branch, selectedAnosafra);

      return {
        ...branch,
        name: branchName,
      };
    });
  } catch (error) {
    console.warn("[Branch][getBranchesOptions]", error);
  }
}

onMounted(async () => {
  await setCurrentAnosafra()
  await searchBranch()
  await getUnities()
  await getBranchesOptions()
});

watch(() => modals.value.modal0, (newValue) => {
  if (!newValue) {
    resetInputs();
    restoreAnosafraOptions()
  }
});
</script>

<style scoped>
.multiple {
  cursor: pointer;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.multiple:hover {
  background-color: #41b883;
  color: white;
}
.multiselect__option--highlight {
  background-color: transparent !important;
  color: #35495e;
}
.multiselect__option--selected.multiselect__option--highlight {
  background-color: rgb(239, 241, 244) !important;
  color: #35495e;
}
.multiselect__option:hover {
  background-color: #41b883  !important; 
  color: white;
} 
.all-selected:hover {
  background-color: #41b883  !important; 
  color: white;
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.all-selected {
  height: 30px;
  padding: 12px 10px 30px 12px;
  cursor: pointer;
}
</style>